import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';

import CompactLayout from 'src/layouts/compact';

import { rootRoute } from './root';

const Page403 = lazy(() => import('src/sections/error/403-view'));

export const forbiddenRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '403',
  component: () => <CompactLayout><Page403/></CompactLayout>,
});
